import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["campaignSelector", "adGroupFrame"];

  connect() {
  }

  selectedCampaignId() {
    // NOTE: The fancy select makes the <label> show up as a target too
    return this.campaignSelectorTargets[1].value;
  }

  adGroupURL() {
    const url = new URL(this.adGroupFrameTarget.src);
    url.searchParams.set('campaign_id', this.selectedCampaignId());

    return url;
  }

  campaignSelected() {
    Turbo.visit(this.adGroupURL(), { frame: "ad_group_select" });
  }
}
